import apiClient, { safeJson } from '@/api/client';
import {
    Ticket,
    CreateTicketBody,
    MemberTicket,
    CreateMemberTicketBody,
    RefundMemberTicketBody,
    MemberTicketBookableSessionsResponse,
    BulkReserveMemberTicketSessionsBody,
    BulkReserveMemberTicketSessionsResponse,
} from './types';

export const createTicket = async (centerId: string, body: CreateTicketBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/tickets`, { json: body });
    return { status: res.status, data: await safeJson(res) as { success: boolean; ticket: Ticket } | null };
};

export const getTickets = async (centerId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/tickets`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: Ticket[] } | null };
};

export const updateTicket = async (centerId: string, ticketId: string, body: Partial<CreateTicketBody>) => {
    const res = await apiClient.put(`v1/centers/${centerId}/tickets/${ticketId}`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const deleteTicket = async (centerId: string, ticketId: string) => {
    const res = await apiClient.delete(`v1/centers/${centerId}/tickets/${ticketId}`);
    return { status: res.status, data: await safeJson(res) };
};

export const createMemberTicket = async (centerId: string, memberId: string, body: CreateMemberTicketBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/members/${memberId}/member-tickets`, { json: body });
    return { status: res.status, data: await safeJson(res) as { success: boolean; memberTicket: MemberTicket } | null };
};

export const getMemberTickets = async (centerId: string, memberId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/members/${memberId}/member-tickets`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: MemberTicket[] } | null };
};

export const getCenterMemberTickets = async (centerId: string, params?: Record<string, string>) => {
    const res = await apiClient.get(`v1/centers/${centerId}/member-tickets`, { searchParams: params });
    return { status: res.status, data: await safeJson(res) as { success: boolean; results: MemberTicket[]; totalResults: number } | null };
};

export const updateMemberTicket = async (centerId: string, memberTicketId: string, body: Partial<MemberTicket>) => {
    const res = await apiClient.put(`v1/centers/${centerId}/member-tickets/${memberTicketId}`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const refundMemberTicket = async (centerId: string, memberTicketId: string, body: RefundMemberTicketBody) => {
    const res = await apiClient.post(`v1/centers/${centerId}/member-tickets/${memberTicketId}/refund`, { json: body });
    return { status: res.status, data: await safeJson(res) };
};

export const getMemberTicketBookableSessions = async (
    centerId: string,
    memberTicketId: string,
    params?: Record<string, string>
) => {
    const res = await apiClient.get(`v1/centers/${centerId}/member-tickets/${memberTicketId}/bookable-sessions`, {
        searchParams: params,
    });
    return { status: res.status, data: await safeJson(res) as MemberTicketBookableSessionsResponse | null };
};

export const bulkReserveMemberTicketSessions = async (
    centerId: string,
    memberTicketId: string,
    body: BulkReserveMemberTicketSessionsBody
) => {
    const res = await apiClient.post(`v1/centers/${centerId}/member-tickets/${memberTicketId}/bulk-reserve`, {
        json: body,
    });
    return { status: res.status, data: await safeJson(res) as BulkReserveMemberTicketSessionsResponse | null };
};
